<template>
  <v-container>
    <v-row>
      <MobileCol>
          <h1>{{ $t('menu.college') }}</h1>
          <v-select
            data-cy="FormCollegeDocument-collegeModuleId"
            filled
            :label="$$t('collegeModuleName')"
            :items="collegeModules"
            :loading="isLoading"
            item-text="name"
            item-value="id"
            v-model="collegeModuleId"
          />
          <v-select
            v-if="collegeModuleId"
            data-cy="FormCollegeDocument-collegeDocumentId"
            filled
            :label="$$t('collegeDocumentId')"
            :items="collegeDocuments"
            :loading="isLoading"
            item-text="title"
            item-value="id"
            v-model="collegeDocumentId"
          />
          <v-btn
            class="mb-5"
            color="primary" v-if="collegeDocumentId"
            block
            @click="newExam">
            <v-icon class="mr-2">{{ mdiHeadQuestionOutline }}</v-icon>
            {{ $$t('writeExam') }}
          </v-btn>
          <v-btn
            class="mb-5"
            color="success" v-if="collegeDocumentId"
            block
            :to="{
              name: 'membership-ViewDocument',
              query: {
                id: this.collegeDocumentId,
                collegeModuleId,
              },
              }">
            <v-icon class="mr-2">{{ mdiEye }}</v-icon>
            {{ $t('common.view') }}
          </v-btn>
          <v-btn class="mt-5 mb-5"
            block color="primary"
            :to="{ name: 'membership-ListCollegeExam' }">
            {{ $$t('myExams') }}
          </v-btn>
          <back-button />
      </MobileCol>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiEye, mdiHeadQuestionOutline } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import MobileCol from '../components/MobileCol.vue';
import BackButton from '../components/BackButton.vue';

export default {
  name: 'College',
  module: 'CollegeDocument',
  mixins: [loading],
  components: {
    MobileCol,
    BackButton,
  },
  data() {
    return {
      mdiEye,
      mdiHeadQuestionOutline,
      collegeModuleId: this.$route.query.collegeModuleId ?? undefined,
      collegeDocumentId: this.$route.query.collegeDocumentId ?? undefined,
    };
  },
  computed: {
    ...mapState('collegeModules', ['collegeModules']),
    ...mapState('collegeDocuments', ['collegeDocuments']),
  },
  watch: {
    collegeModuleId: {
      immediate: true,
      deep: true,
      handler() {
        this.loadCollegeDocuments();
      },
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_collegeModules();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('collegeDocuments', ['LOAD_collegeDocuments', 'DELETE_collegeDocument']),
    ...mapActions('collegeExams', ['CREATE_collegeExam', 'DELETE_collegeDocument']),
    ...mapActions('collegeModules', ['LOAD_collegeModules']),
    async loadCollegeDocuments() {
      if (this.collegeModuleId) {
        this.isLoading = true;
        await this.LOAD_collegeDocuments(this.collegeModuleId);
        this.isLoading = false;
      }
    },
    async newExam() {
      this.isLoading = true;
      const collegeExam = await this.CREATE_collegeExam({
        collegeDocumentId: this.collegeDocumentId,
      });
      this.isLoading = false;
      this.$router.push({
        name: 'membership-CollegeExam',
        query: { collegeExamId: collegeExam.id },
      });
    },
  },
};
</script>
